import { Injectable } from '@angular/core';
import { IDataCaptureSheet } from '../models/data-capture.models';

export interface IDataCaptureSheetDefaults extends Pick<
  IDataCaptureSheet,
  | 'name'
  | 'discussion_guide'
  | 'answer_format'
  | 'additional_export_headers'
  | 'suggested_question_threshold'
> {}

@Injectable()
export class DataCaptureSheetService {
  private sheetDefaultsInner: Partial<IDataCaptureSheetDefaults> = {};

  get sheetDefaults(): Partial<IDataCaptureSheetDefaults> {
    return this.sheetDefaultsInner;
  }

  set sheetDefaults(value: Partial<IDataCaptureSheetDefaults>) {
    this.sheetDefaultsInner = value;
  }
}
